import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { _http } from './js/utils/http';

import ElementUI from 'element-ui';
import '@/assets/styles/element-variables.scss';
Vue.prototype._http = _http; //api调用方式

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
